module.exports = __webpack_public_path__ + "assets/media/arrow.380422cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/ConvoPreview/arrow.svg
// module id = 2073
// module chunks = 0